import React from 'react';
import { Box, SxProps } from '@mui/material';
import CheckboxComponent from '../../Common/Fields/CheckboxComponent';

type IProps = {
  data: any[];
  handleCheckClicked: (id: string) => void;
  clickedValues: string[];
  editable: boolean;
  staticGrid?: boolean;
};

const ContentGrid: React.FunctionComponent<IProps> = ({
  data,
  handleCheckClicked,
  clickedValues,
  editable,
  staticGrid = false
}: IProps) => {
  const getCleanName = (name: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return name.replaceAll(' ', '-');
  };

  const getContainerStyle = () => {
    const notStatic = { display: 'flex', flexWrap: 'wrap', columnGap: '12px' } as SxProps;
    const staticFlex = {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
      columnGap: '12px'
    } as SxProps;
    return staticGrid ? staticFlex : notStatic;
  };

  return (
    <Box sx={getContainerStyle()}>
      {data.map((value, index) => (
        <CheckboxComponent
          id={`${value.id}-${getCleanName(value.name)}-checkbox`}
          key={index}
          disabled={!editable}
          onChange={() => handleCheckClicked(value?.id as string)}
          value={clickedValues.includes(value.id as string)}
          label={value.name}
        />
      ))}
    </Box>
  );
};

export default ContentGrid;
